module.exports = __webpack_public_path__ + "img/sous_vide.22fcd820.png";